import { IOrderTypeSetAction } from './types';
import { AT_ORDER_TYPE_SET } from './constants';
import { IOrderType } from '../types';

export const orderTypeSetAction = (
    orderType: IOrderType
): IOrderTypeSetAction => ({
        type: AT_ORDER_TYPE_SET,
        orderType
    }
);
